module.exports = __webpack_public_path__ + "img/whatsapp.1f25178b.png";